import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import SetOutfitPreview from "../../features/previews/set_outfit/SetOutfitPreview";
import SetOutfitNodePreview from "../../features/sequence/node_previews/SetOutfitNodePreview";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { InteractionProperty } from "../InteractionProperty";
import Interaction, { InteractionType } from "./Interaction";
import { ValidationHelper } from "./../../features/validation/ValidationHelper";
import Take from "../Take";
import { Prop } from "../Prop";
import { LocalizedStringRecord } from "../../app/slices/TrainingLocalizationSlice";
import { Actor } from "../Actor";
import {
  compactSearchableStrings,
  SearchLookupContext,
} from "./SearchableInteractionValues";

export interface ISetOutfit extends Interaction {
  actorId: string;
  outfitName: string;
}

const requiredSetOutfitProperties: InteractionProperty[] = [];

export const setOutfitInteraction = (): InteractionFactoryEntity => {
  const view = <SetOutfitPreview />;

  const create = (getKeys: (amount: number) => string[]): ISetOutfit => {
    return {
      id: GetNewGuid(),
      name: "Set Outfit",
      type: InteractionType.SetOutfit,
      actorId: "player",
      outfitName: "",
      properties: requiredSetOutfitProperties,
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction
  ): ISetOutfit => {
    return interaction as ISetOutfit;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[],
    replaceKey: (from: string, to: string) => void
  ): ISetOutfit => {
    const setOutfit = create(getKeys);
    const original = interaction as ISetOutfit;

    setOutfit.actorId = original.actorId;
    setOutfit.outfitName = original.outfitName;

    return setOutfit;
  };

  const validate = (interaction: Interaction): string[] => {
    const casted = interaction as ISetOutfit;
    const results: string[] = [];

    return results;
  };

  const validateErrors = (
    interaction: Interaction,
    parentTake: Take,
    currentTake: Take,
    actorPresets: Actor[],
    allPropPresets: Prop[],
    localizedStringRecords: LocalizedStringRecord
  ): string[] => {
    const casted = interaction as ISetOutfit;
    const results: string[] = [];

    if (!casted.outfitName || casted.outfitName.trim() === "") {
      results.push("Please select an outfit");
    }

    if (!casted.actorId || casted.actorId.trim() === "") {
      results.push("Please select a target actor");
    }

    return results;
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string
    ) => SearchResultData[],
    _getValue: (key: string) => string,
    searchLookupContext?: SearchLookupContext,
  ): SearchResultData[] => {
    const converted = interaction as ISetOutfit;

    return getMatchingResults(
      compactSearchableStrings(
        interaction.name,
        converted.outfitName,
        searchLookupContext?.getActorSearchTerms(converted.actorId) ??
          converted.actorId,
      ),
      takeName,
      interaction,
      filterType
    );
  };

  const filterType: string = "Set Outfit";

  return {
    View: view,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <SetOutfitNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    FilterType: filterType,
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateErrors,
  };
};
